import { render, staticRenderFns } from "./FlowInput.vue?vue&type=template&id=1c237f21&scoped=true&"
import script from "./FlowInput.vue?vue&type=script&lang=js&"
export * from "./FlowInput.vue?vue&type=script&lang=js&"
import style0 from "./FlowInput.vue?vue&type=style&index=0&id=1c237f21&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c237f21",
  null
  
)

export default component.exports